import React, { useEffect, useState } from "react"
import { Card, Container } from "reactstrap"
import Loader from "./Loader"
import Breadcrumbs from "components/Common/Breadcrumb"
import { axiosbaseurl } from "config"
import { FiRefreshCw } from "react-icons/fi"
import moment from "moment"
import {
  FaArrowCircleDown,
  FaArrowCircleUp,
} from "react-icons/fa"
import { Modal } from "antd"

const LiveMarket = () => {
  document.title = "Live Market | Return First Investments"

  const [Loading, setLoading] = useState(false)
  const [Data, setData] = useState({})
  const [Gainers, setGainers] = useState([])
  const [AllGainersOrLosers, setAllGainersOrLosers] = useState([])
  const [Losers, setLosers] = useState([])
  const [Intraday, setIntraday] = useState([])
  const [SensexData, setSensexData] = useState({})
  const [Nifty50Data, setNifty50Data] = useState({})
  const [BankNiftyData, setBankNiftyData] = useState({})
  const [selectedData, setSelectedData] = useState(null)
  const [StockData, setStockData] = useState({})
  const [ModalTitle, setModalTitle] = useState("")

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date()

      const istOffset = 5.5 * 60
      const localOffset = now.getTimezoneOffset()
      const istTime = new Date(
        now.getTime() + (istOffset + localOffset) * 60000
      )

      const hours = istTime.getHours()
      const minutes = istTime.getMinutes()

      const isWithinTimeRange =
        (hours > 9 || (hours === 9 && minutes >= 15)) &&
        (hours < 15 || (hours === 15 && minutes <= 30))

      if (isWithinTimeRange) {
        getRegularData()
      }
    }, 10000)

    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const [response, response2, response3, response4] = await Promise.all([
        axiosbaseurl.get(`yahoo/finance/indices/data`),
        axiosbaseurl.get(`stocks/top/gainers`),
        axiosbaseurl.get(`stocks/top/losers`),
        axiosbaseurl.get(`stocks/intraday`),
      ])
      if (response?.data?.success) {
        setData(response?.data)
        setSensexData(response?.data?.sensex)
        setNifty50Data(response?.data?.nifty)
        setBankNiftyData(response?.data?.bankNifty)
      }
      if (response2?.data?.success) {
        setGainers(response2?.data?.data?.data)
      }
      if (response3?.data?.success) {
        setLosers(response3?.data?.data?.data)
      }
      if (response4?.data?.success) {
        setIntraday(response4?.data?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  async function getRegularData() {
    try {
      const [response, response2, response3, response4] = await Promise.all([
        axiosbaseurl.get(`yahoo/finance/indices/data`),
        axiosbaseurl.get(`stocks/top/gainers`),
        axiosbaseurl.get(`stocks/top/losers`),
        axiosbaseurl.get(`stocks/intraday`),
      ])
      if (response?.data?.success) {
        setData(response?.data)
        setSensexData(response?.data?.sensex)
        setNifty50Data(response?.data?.nifty)
        setBankNiftyData(response?.data?.bankNifty)
      }
      if (response2?.data?.success) {
        setGainers(response2?.data?.data?.data)
      }
      if (response3?.data?.success) {
        setLosers(response3?.data?.data?.data)
      }
      if (response4?.data?.success) {
        setIntraday(response4?.data?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response?.data?.message)
    }
  }

  async function getStockDataBySymbol(Sym, Exchange) {
    setLoading(true)
    try {
      const response = await axiosbaseurl.post(
        `yahoo/finance/quote/symbol/${Sym}`,
        {
          Exchange,
        }
      )
      if (response?.data?.success) {
        setStockData(response?.data?.quote)
      }
    } catch (e) {
      console.log("Error", e.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  async function getAllGainers() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`stocks/all/gainers`)
      if (response?.data?.success) {
        setAllGainersOrLosers(response?.data?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  async function getAllLosers() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`stocks/all/losers`)
      if (response?.data?.success) {
        setAllGainersOrLosers(response?.data?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  const [StockModal, setStockModal] = useState(false)
  const [IndicesModal, setIndicesmodal] = useState(false)
  const [ViewStockModal, setViewStockmodal] = useState(false)

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={""} breadcrumbItem={"Market"} />
          <div className="card p-2 py-3">
            <div className="px-3">
              {/* Masonry Grid Layout */}
              <h5 className="mt-4">Indices</h5>
              <div className="row mt-3">
                <div className="col-xl-4">
                  <Card
                    className="p-3 Stock-card"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIndicesmodal(true)
                      setSelectedData(SensexData)
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Sensex</h5>
                      <img
                        src="https://stock-logos.dhan.co/static-openweb/BSE_Logo.svg"
                        height={50}
                        width={50}
                        className="overflow-hidden"
                        alt="Sensex"
                      />
                    </div>
                    <h5>
                      {Data?.sensex?.regularMarketPrice.toFixed(2)}{" "}
                      <span
                        className={`fs-6 ${
                          Data?.sensex?.regularMarketChangePercent < 0
                            ? "text-danger"
                            : "text-success"
                        }`}
                      >
                        {Data?.sensex?.regularMarketChange.toFixed(2)} (
                        {Data?.sensex?.regularMarketChangePercent.toFixed(2)}%)
                      </span>
                      {Data?.sensex?.regularMarketChangePercent < 0 ? (
                        <FaArrowCircleDown className="text-danger ms-2" />
                      ) : (
                        <FaArrowCircleUp className="text-success ms-2" />
                      )}
                    </h5>
                  </Card>
                </div>
                <div className="col-xl-4">
                  <Card
                    className="p-3 Stock-card"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIndicesmodal(true)
                      setSelectedData(Nifty50Data)
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Nifty 50</h5>
                      <img
                        src="https://stock-logos.dhan.co/static-openweb/NSE_Logo.svg"
                        height={50}
                        width={50}
                        className="overflow-hidden"
                        alt="Nifty 50"
                      />
                    </div>
                    <h5>
                      {Data?.nifty?.regularMarketPrice.toFixed(2)}{" "}
                      <span
                        className={`fs-6 ${
                          Data?.nifty?.regularMarketChangePercent < 0
                            ? "text-danger"
                            : "text-success"
                        }`}
                      >
                        {Data?.nifty?.regularMarketChange.toFixed(2)} (
                        {Data?.nifty?.regularMarketChangePercent.toFixed(2)}%)
                      </span>
                      {Data?.nifty?.regularMarketChangePercent < 0 ? (
                        <FaArrowCircleDown className="text-danger ms-2" />
                      ) : (
                        <FaArrowCircleUp className="text-success ms-2" />
                      )}
                    </h5>
                  </Card>
                </div>
                <div className="col-xl-4">
                  <Card
                    className="p-3 Stock-card"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIndicesmodal(true)
                      setSelectedData(BankNiftyData)
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Bank Nifty</h5>
                      <img
                        src="https://stock-logos.dhan.co/static-openweb/NSE_Logo.svg"
                        height={50}
                        width={50}
                        className="overflow-hidden"
                        alt="Bank Nifty"
                      />
                    </div>
                    <h5>
                      {Data?.bankNifty?.regularMarketPrice.toFixed(2)}{" "}
                      <span
                        className={`fs-6 ${
                          Data?.bankNifty?.regularMarketChangePercent < 0
                            ? "text-danger"
                            : "text-success"
                        }`}
                      >
                        {Data?.bankNifty?.regularMarketChange.toFixed(2)} (
                        {Data?.bankNifty?.regularMarketChangePercent.toFixed(2)}
                        %)
                      </span>
                      {Data?.bankNifty?.regularMarketChangePercent < 0 ? (
                        <FaArrowCircleDown className="text-danger ms-2" />
                      ) : (
                        <FaArrowCircleUp className="text-success ms-2" />
                      )}
                    </h5>
                  </Card>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mt-4">Top Gainers</h5>
                <h5
                  style={{ cursor: "pointer" }}
                  className="mt-4"
                  onClick={() => {
                    getAllGainers()
                    setViewStockmodal(true)
                    setModalTitle("Top Gainers")
                  }}
                >
                  View All
                </h5>
              </div>

              <div className="row mt-3">
                {Gainers?.map(item => {
                  return (
                    <div className="col-xl-3" key={item.Isin}>
                      <Card
                        className="p-3 Stock-card"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          getStockDataBySymbol(item.Sym, item.Exch)
                          setStockModal(true)
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <h5>{item?.Sym}</h5>
                          <img
                            src={`https://images.dhan.co/symbol/${item?.Sym}.png`}
                            height={50}
                            width={50}
                            alt={item?.Sym}
                            className="overflow-hidden"
                          />
                        </div>
                        <h5>
                          ₹ {item?.Ltp.toFixed(2)}{" "}
                          <span
                            className={`fs-6 ${
                              item?.PPerchange < 0
                                ? "text-danger"
                                : "text-success"
                            }`}
                          >
                            {item?.PPerchange.toFixed(2)}%
                          </span>
                          {item?.PPerchange < 0 ? (
                            <FaArrowCircleDown className="text-danger ms-2" />
                          ) : (
                            <FaArrowCircleUp className="text-success ms-2" />
                          )}
                        </h5>
                      </Card>
                    </div>
                  )
                })}
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mt-4">Top Losers</h5>
                <h5
                  style={{ cursor: "pointer" }}
                  className="mt-4"
                  onClick={() => {
                    getAllLosers()
                    setViewStockmodal(true)
                    setModalTitle("Top Losers")
                  }}
                >
                  View All
                </h5>
              </div>

              <div className="row mt-3">
                {Losers?.map(item => {
                  return (
                    <div className="col-xl-3" key={item.Isin}>
                      <Card
                        className="p-3 Stock-card"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          getStockDataBySymbol(item.Sym, item.Exch)
                          setStockModal(true)
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <h5>{item?.Sym}</h5>
                          <img
                            src={`https://images.dhan.co/symbol/${item?.Sym}.png`}
                            height={50}
                            width={50}
                            alt={item?.Sym}
                            className="overflow-hidden"
                          />
                        </div>
                        <h5>
                          ₹ {item?.Ltp.toFixed(2)}{" "}
                          <span
                            className={`fs-6 ${
                              item?.PPerchange < 0
                                ? "text-danger"
                                : "text-success"
                            }`}
                          >
                            {item?.PPerchange.toFixed(2)}%
                          </span>
                          {item?.PPerchange < 0 ? (
                            <FaArrowCircleDown className="text-danger ms-2" />
                          ) : (
                            <FaArrowCircleUp className="text-success ms-2" />
                          )}
                        </h5>
                      </Card>
                    </div>
                  )
                })}
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mt-4">Top Intraday Stocks</h5>
                {/* <h5 style={{ cursor: "pointer" }} className="mt-4">
                  View All
                </h5> */}
              </div>

              <div className="row mt-3">
                {Intraday?.map(item => {
                  return (
                    <div className="col-xl-3" key={item.Isin}>
                      <Card
                        className="p-3 Stock-card"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          getStockDataBySymbol(item.Sym, item.Exch)
                          setStockModal(true)
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <h5>{item?.Sym}</h5>
                          <img
                            src={`https://images.dhan.co/symbol/${item?.Sym}.png`}
                            height={50}
                            width={50}
                            alt={item?.Sym}
                            className="overflow-hidden"
                          />
                        </div>
                        <h5>
                          ₹ {item?.Ltp.toFixed(2)}{" "}
                          <span
                            className={`fs-6 ${
                              item?.PPerchange < 0
                                ? "text-danger"
                                : "text-success"
                            }`}
                          >
                            {item?.PPerchange.toFixed(2)}%
                          </span>
                          {item?.PPerchange < 0 ? (
                            <FaArrowCircleDown className="text-danger ms-2" />
                          ) : (
                            <FaArrowCircleUp className="text-success ms-2" />
                          )}
                        </h5>
                      </Card>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </Container>
      </div>

      <Modal
        open={IndicesModal}
        onCancel={() => setIndicesmodal(false)}
        footer={null}
        title={selectedData?.shortName}
        width={950}
        data={selectedData}
      >
        <div className="bg-white rounded-4 p-3">
          <div className="row">
            <div className="col-xl-4">
              <div>
                <lable className="text-secondary fw-bold">Name</lable>
                <p className="bg-light p-2 rounded">{selectedData?.longName}</p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Day High
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.regularMarketDayHigh}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Day Low
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.regularMarketDayLow}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Previous Close
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.regularMarketPreviousClose}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Open
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.regularMarketOpen}
                </p>
              </div>
            </div>
            <div className="col-xl-4">
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Two Week Low Change
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.fiftyTwoWeekLowChange.toFixed(2)}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Two Week Low Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.fiftyTwoWeekLowChangePercent.toFixed(2)}%
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Two Week High Change
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.fiftyTwoWeekHighChange.toFixed(2)}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Two Week High Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.fiftyTwoWeekHighChangePercent.toFixed(2)}%
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Day Average Change
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.fiftyDayAverageChange.toFixed(2)}
                </p>
              </div>
            </div>
            <div className="col-xl-4">
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Day Average Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.fiftyDayAverageChangePercent.toFixed(2)}%
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.regularMarketChangePercent.toFixed(2)}%
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Price
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.regularMarketPrice.toFixed(2)}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Two Hundred Day Average Change
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.twoHundredDayAverageChange.toFixed(2)}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Two Hundred Day Average Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {selectedData?.twoHundredDayAverageChangePercent.toFixed(2)}%
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={StockModal}
        onCancel={() => setStockModal(false)}
        footer={null}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img
              src={`https://images.dhan.co/symbol/${
                StockData?.symbol?.split(".")?.[0]
              }.png`}
              style={{ width: 36, height: 36 }}
              className="overflow-hidden"
            />
            <div>
              <div style={{ fontWeight: "bold", fontSize: 18 }}>
                {StockData?.shortName || "Stock Details"}
              </div>
            </div>
          </div>
        }
        width={950}
      >
        <div className="bg-white rounded-4 p-3">
          <div className="row">
            <div className="col-xl-4">
              <div>
                <lable className="text-secondary fw-bold">Name</lable>
                <p className="bg-light p-2 rounded">{StockData?.longName}</p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Day High
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.regularMarketDayHigh}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Day Low
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.regularMarketDayLow}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Previous Close
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.regularMarketPreviousClose}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Open
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.regularMarketOpen}
                </p>
              </div>
            </div>
            <div className="col-xl-4">
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Two Week Low Change
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.fiftyTwoWeekLowChange?.toFixed(2)}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Two Week Low Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {StockData?.fiftyTwoWeekLowChangePercent?.toFixed(2)}%
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Two Week High Change
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.fiftyTwoWeekHighChange?.toFixed(2)}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Two Week High Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {StockData?.fiftyTwoWeekHighChangePercent?.toFixed(2)}%
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Day Average Change
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.fiftyDayAverageChange?.toFixed(2)}
                </p>
              </div>
            </div>
            <div className="col-xl-4">
              <div>
                <lable className="text-secondary fw-bold">
                  Fifty Day Average Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {StockData?.fiftyDayAverageChangePercent?.toFixed(2)}%
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {StockData?.regularMarketChangePercent?.toFixed(2)}%
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Regular Market Price
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.regularMarketPrice?.toFixed(2)}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Two Hundred Day Average Change
                </lable>
                <p className="bg-light p-2 rounded">
                  ₹ {StockData?.twoHundredDayAverageChange?.toFixed(2)}
                </p>
              </div>
              <div>
                <lable className="text-secondary fw-bold">
                  Two Hundred Day Average Change Percent
                </lable>
                <p className="bg-light p-2 rounded">
                  {StockData?.twoHundredDayAverageChangePercent?.toFixed(2)}%
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={ViewStockModal}
        onCancel={() => {
          setViewStockmodal(false)
          setModalTitle("")
        }}
        footer={null}
        title={ModalTitle}
        width={800}
      >
        <div
          className="bg-white rounded-4 px-4 scrollable-content"
          style={{ maxHeight: "65vh", overflowY: "auto" }}
        >
          {AllGainersOrLosers?.map(item => {
            return (
              <div
                className="d-flex justify-content-between align-items-center my-2 p-2 rounded bg-light"
                key={item.Isin}
              >
                <div className="d-flex align-items-center">
                  <img
                    src={`https://images.dhan.co/symbol/${item?.Sym}.png`}
                    height={30}
                    width={30}
                    alt={item?.Sym}
                    className="overflow-hidden"
                  />
                  <h6 className="ms-4 fw-bold">{item?.DispSym}</h6>
                </div>
                <div className="d-flex justify-content-between align-items-center width-threethree">
                  <p className="bg-white px-2 py-1 rounded fs-6 fw-bold">
                    {item?.Exch}
                  </p>
                  <p>
                    <span className="me-2">₹ {item?.Ltp.toFixed(2)} </span>
                    <span
                      className={`fs-6 ${
                        item?.PPerchange < 0
                          ? "text-danger"
                          : "text-brand-green"
                      }`}
                    >
                      {item?.PPerchange.toFixed(2)}%
                    </span>
                    {item?.PPerchange < 0 ? (
                      <FaArrowCircleDown className="text-danger ms-2" />
                    ) : (
                      <FaArrowCircleUp className="text-brand-green ms-2" />
                    )}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default LiveMarket
